"use client";
import React from "react";
import { useTranslation } from "react-i18next";
import PharmacyCard from "../PharmacyCard/PharmacyCard";
import "./PharmacyList.css";

export default function PharmacyList({ pharmacies = [], onPharmacyClick, selectedPharmacy }) {
  const { t } = useTranslation();

  // 👇 Limit here
  const limitedList = pharmacies.slice(0, 20);

  if (!limitedList || limitedList.length === 0) {
    return <p>🔍 {t("locators.pharmacy.empty")}</p>;
  }

  return (
    <div className="pharmacy-list">
      {limitedList.map((pharmacy) => (
        <PharmacyCard
          key={pharmacy.place_id || pharmacy.id}
          pharmacy={pharmacy}
          selectedPharmacy={selectedPharmacy}
          onClick={onPharmacyClick}
        />
      ))}
    </div>
  );
}
